  let swiperInstance = null;

  function initSwiperIfMobile() {
    const isMobile = window.innerWidth < 768;

    if (isMobile && !swiperInstance) {
      swiperInstance = new Swiper('.video-slider-wrapper .swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        pagination: {
          el: '.video-slider-wrapper .swiper-pagination',
          clickable: true,
          type: 'bullets'
        }
      });
    } else if (!isMobile && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }


  window.addEventListener('load', () => {
    initSwiperIfMobile();

    // 🔁 영상 클릭 시 재생/정지 토글
    document.querySelectorAll('.video-slider-wrapper .video-wrapper video').forEach(video => {
      video.addEventListener('click', function () {
        const wrapper = video.closest('.video-slider-wrapper .video-wrapper');

        if (video.paused) {
          // 다른 영상 정지
          document.querySelectorAll('.video-slider-wrapper .video-wrapper').forEach(w => {
            const v = w.querySelector('video');
            if (v !== video) {
              v.pause();
              w.classList.remove('playing');
            }
          });

          video.play();
          wrapper.classList.add('playing');
        } else {
          video.pause();
          wrapper.classList.remove('playing');
        }
      });
    });
  });

  window.addEventListener('resize', initSwiperIfMobile);

  function handlePlay(button) {
    const wrapper = button.closest('.video-slider-wrapper .video-wrapper');
    const video = wrapper.querySelector('video');

    // 다른 영상 정지
    document.querySelectorAll('.video-slider-wrapper .video-wrapper').forEach(w => {
      const v = w.querySelector('video');
      if (v !== video) {
        v.pause();
        w.classList.remove('playing');
      }
    });

    // 토글 재생
    if (video.paused) {
      video.play();
      wrapper.classList.add('playing');
    } else {
      video.pause();
      wrapper.classList.remove('playing');
    }
  }
